import { ReviewResponseResponseBuilder } from 'gql/autogen/ReviewResponseResponseBuilder';
import { ReviewActivityResultResponseBuilder } from 'gql/autogen/ReviewActivityResultResponseBuilder';
import { ReviewResultInfoResponseBuilder } from 'gql/autogen/ReviewResultInfoResponseBuilder';
import { PaginationResponseBuilder } from 'gql/autogen/PaginationResponseBuilder';
import { ActivityReviewResponseBuilder } from 'gql/autogen/ActivityReviewResponseBuilder';
import { MediaResponseBuilder } from 'gql/autogen/MediaResponseBuilder';
import { ReplyResponseBuilder } from 'gql/autogen/ReplyResponseBuilder';
import { SearchErrorResponseBuilder } from 'gql/autogen/SearchErrorResponseBuilder';
import { MatrixResponseBuilder } from 'gql/autogen/MatrixResponseBuilder';
import { SortMatrixResponseBuilder } from 'gql/autogen/SortMatrixResponseBuilder';
import { FilterMatrixResponseBuilder } from 'gql/autogen/FilterMatrixResponseBuilder';
import { RangeFilterMatrixResponseBuilder } from 'gql/autogen/RangeFilterMatrixResponseBuilder';
import { BucketMatrixResponseBuilder } from 'gql/autogen/BucketMatrixResponseBuilder';
import { ValueFilterMatrixResponseBuilder } from 'gql/autogen/ValueFilterMatrixResponseBuilder';
import { ValueMatrixResponseBuilder } from 'gql/autogen/ValueMatrixResponseBuilder';

// DO NOT REMOVE FOLLOWING LINE, We need this line to select fields in the query
// prettier-ignore
const build = (): ReviewResponseResponseBuilder => {
    return new ReviewResponseResponseBuilder()
        .withIsSuccess()
        .withResult(
            new ReviewActivityResultResponseBuilder()
                .withIsCompleted()
                .withResultInfo(
                    new ReviewResultInfoResponseBuilder()
                        .withTotalReviews()
                        .withTotalFilteredReviews()
                        .withPagination(
                            new PaginationResponseBuilder()
                                .withSize()
                                .withNumber()
                        ),
                )
                .withMasterActivityId()
                .withMasterSupplierId()
                .withReviewScore()
                .withReviews(
                    new ActivityReviewResponseBuilder()
                        .withReviewId()
                        .withReviewSource()
                        .withAuthorName()
                        .withTitle()
                        .withReviewText()
                        .withReviewDateTime()
                        .withReviewScore()
                        .withHelpfulVoteCount()
                        .withIsTranslationRequired()
                        .withMedia(
                            new MediaResponseBuilder()
                                .withMediaType()
                                .withSource()
                                .withDescription()
                        )
                        .withReplies(
                            new ReplyResponseBuilder()
                                .withReplyId()
                                .withAuthorType()
                                .withReplyDateTime()
                                .withReplyText()
                        ),
                )
                .withMatrix(
                    new MatrixResponseBuilder()
                        .withSort(
                            new SortMatrixResponseBuilder()
                                .withAvailableCode()
                                .withAvailableOrder()
                        )
                        .withFilter(
                            new FilterMatrixResponseBuilder()
                                .withRangeFilterMatrix(
                                    new RangeFilterMatrixResponseBuilder()
                                        .withCode()
                                        .withMin()
                                        .withMax()
                                        .withBucket(
                                            new BucketMatrixResponseBuilder()
                                                .withCount()
                                                .withMin()
                                                .withMax()
                                        ),
                                )
                                .withValueFilterMatrix(
                                    new ValueFilterMatrixResponseBuilder()
                                        .withAvailableValue(
                                            new ValueMatrixResponseBuilder()
                                                .withCount()
                                                .withId()
                                        )
                                        .withCode()
                                ),
                        ),
                ),
        )
        .withErrors(
            new SearchErrorResponseBuilder()
                .withErrorCode()
                .withSubErrorCode()
                .withMessage()
        )
};

export default build;
